<div *ngIf="!creatingDeal">
  <div class="header">
    <ng-container *ngIf="selectedProperties?.length; else ChildIdTitle">
      <div class="title">
        @if (data?.mode === 'link') {
          Link Deal with {{ selectedProperties?.length }}
          {{
            selectedProperties?.length
              | i18nPlural
                : {
                    '=0': 'No properties',
                    '=1': 'property',
                    other: 'properties',
                  }
          }}
        } @else {
          Create Deal with {{ selectedProperties?.length }}
          {{
            selectedProperties?.length
              | i18nPlural
                : {
                    '=0': 'No properties',
                    '=1': 'property',
                    other: 'properties',
                  }
          }}
        }
      </div>
    </ng-container>
    <ng-template #ChildIdTitle>
      <div class="title" *ngIf="data.child_ids">
        Create Portfolio with {{ data.child_ids?.length }}
        {{
          data.child_ids?.length
            | i18nPlural
              : {
                  '=0': 'No deals',
                  '=1': 'child deal',
                  other: 'child deals',
                }
        }}
      </div>
    </ng-template>

    <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
      <mat-icon [svgIcon]="'close'"></mat-icon>
    </button>
  </div>
  @if (data?.mode === 'link') {
    <form [formGroup]="linkDealForm" (submit)="save()">
      <div class="flex flex-col gt-xs:flex-row w-full">
        <mat-form-field class="w-full">
          <mat-label>Deal</mat-label>
          <input
            matInput
            placeholder="Select a Deal"
            [formControlName]="'name'"
            [matAutocomplete]="dealAutoComplete"
            [spellcheck]="false"
          />
        </mat-form-field>
        <mat-autocomplete
          #dealAutoComplete="matAutocomplete"
          [disableRipple]="true"
          (optionSelected)="autocompleteSelected($event)"
        >
          <mat-option *ngIf="dealOptions() && !dealOptions().length"> No results found! </mat-option>
          <mat-option *ngFor="let option of dealOptions()" [value]="option.name" [id]="option.id">
            {{ option.name }}
          </mat-option>
        </mat-autocomplete>
      </div>
      <div class="actions">
        <div class="formatting"></div>
        <div class="buttons">
          <button class="discard-button" mat-button type="button" (click)="discard()">
            <span>Cancel</span>
          </button>
          <button
            class="send-button"
            mat-flat-button
            type="submit"
            [color]="'primary'"
            [disabled]="linkDealForm.pristine || linkDealForm.invalid || linkDealForm.disabled"
            data-cy="save-portfolio"
          >
            <span *ngIf="!linkDealForm.disabled">Save</span>
            <mat-progress-spinner *ngIf="linkDealForm.disabled" [diameter]="24" [mode]="'indeterminate'">
            </mat-progress-spinner>
          </button>
        </div>
      </div>
    </form>
  } @else {
    <form
      [formGroup]="addProjectForm"
      *ngIf="isDealsDetailView; else optionalView"
      (submit)="addProjectForm.pristine || addProjectForm.invalid ? null : save()"
    >
      <div class="flex flex-col gt-xs:flex-row">
        <mat-form-field class="flex-auto gt-xs:pr-3">
          <mat-label>Deal Name</mat-label>
          <input matInput placeholder="Enter Deal name" [formControlName]="'title'" data-cy="deal-name-input" />
        </mat-form-field>
        <mat-hint *ngIf="duplicateProjects?.length > 0" class="mb-3">
          One or more deals with the same name already exists:
          <ul>
            <li *ngFor="let project of duplicateProjects">
              <a class="link" (click)="goToDeal(project)">{{ project.title }}</a>
            </li>
          </ul>
        </mat-hint>
        <mat-hint *ngIf="duplicateAddressProjects?.length > 0" class="mb-3">
          One or more deals with the same address already exists:
          <ul>
            <li *ngFor="let project of duplicateAddressProjects">
              <a class="link" (click)="goToDeal(project)">{{ project.title }}</a>
            </li>
          </ul>
        </mat-hint>
        <mat-form-field class="flex-auto gt-xs">
          <mat-label>View</mat-label>
          <mat-select [formControlName]="'pipeline_id'" placeholder="--Select--" data-cy="pipeline-type-select">
            <mat-option *ngFor="let pipeline of pipelines" [value]="pipeline.id">
              {{ pipeline.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="flex flex-col gt-xs:flex-row">
        <mat-form-field class="flex-auto gt-xs">
          <mat-label *ngIf="this.dealType === 'portfolio'">Portfolio Deal Layout</mat-label>
          <mat-label *ngIf="this.dealType !== 'portfolio'">Deal Layout</mat-label>
          <mat-select
            [formControlName]="'template_id'"
            placeholder="--Select--"
            data-cy="portfolio-layout-parent-select"
          >
            <mat-option *ngFor="let projectTemplate of projectTemplates" [value]="projectTemplate.id">
              {{ projectTemplate.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="flex-auto gt-xs:pl-3" *ngIf="this.dealType === 'portfolio'">
          <mat-label>Child Deal Layout</mat-label>
          <mat-select
            [formControlName]="'child_template_id'"
            placeholder="--Select--"
            data-cy="portfolio-layout-child-select"
          >
            <mat-option *ngFor="let projectTemplate of projectTemplates" [value]="projectTemplate.id">
              {{ projectTemplate.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="actions">
        <div class="formatting"></div>
        <div class="buttons">
          <button class="discard-button" mat-button type="button" (click)="discard()">
            <span>Cancel</span>
          </button>
          <button
            class="send-button"
            mat-flat-button
            type="submit"
            [color]="'primary'"
            [disabled]="addProjectForm.pristine || addProjectForm.invalid"
            data-cy="save-portfolio"
          >
            <span *ngIf="!addProjectForm.disabled">Save</span>
            <mat-progress-spinner *ngIf="addProjectForm.disabled" [diameter]="24" [mode]="'indeterminate'">
            </mat-progress-spinner>
          </button>
        </div>
      </div>
    </form>
    <ng-template #optionalView>
      <div class="flex flex-wrap p-6 optional-view items-center">
        <div class="flex flex-row w-1/2 px-6 pb-0">
          <ng-container *ngIf="lookupField('project_stage_id') as fieldDef">
            <app-form-field
              [fieldDef]="fieldDef"
              [model]="project"
              (onUpdate)="updated()"
              [data]="options"
              class="w-full"
            ></app-form-field>
          </ng-container>
        </div>
        <div class="flex flex-row w-1/2 px-6 pb-0" *ngFor="let column of displayColumns">
          <ng-container *ngIf="lookupField(column) as fieldDef">
            <app-form-field
              [fieldDef]="fieldDef"
              [model]="project"
              (onUpdate)="updated()"
              [data]="options"
              class="w-full"
            ></app-form-field>
          </ng-container>
        </div>
        <div class="flex justify-end actions w-full px-3">
          <div class="buttons">
            <button class="discard-button mr-1" mat-button (click)="discard()">
              <span>Skip</span>
            </button>
            <button class="discard-button mr-1" mat-button (click)="goToDeal()">
              <span>Go To Deal</span>
            </button>
            <button class="send-button" mat-flat-button [color]="'primary'" (click)="discard()">Finish</button>
          </div>
        </div>
      </div>
    </ng-template>
  }
</div>
<div *ngIf="creatingDeal">
  <div class="header">
    <div class="title">Saving Deal</div>
  </div>
  <div class="flex items-center" style="flex-direction: column; padding: 80px 50px">
    <mat-progress-spinner *ngIf="addProjectForm.disabled" [diameter]="75" [mode]="'indeterminate'">
    </mat-progress-spinner>
    <div style="margin-top: 40px">This may take up to a few minutes.</div>
  </div>
</div>
